export var shiftHasSwapRequest = function (swapRequestsForDay, shiftStart) {
    if (!swapRequestsForDay.length) {
        return false;
    }
    var swapRequest = swapRequestsForDay[0];
    return swapRequest.from.shifts.some(function (swapRequest) { return swapRequest.timeRange.start === shiftStart; });
};
